import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/_services/http-request.service';
import { CashDividend } from 'src/app/_models/cash-dividend';
import { DataSharingService } from 'src/app/_services/data-sharing.service';
import { tap } from 'rxjs/operators';
import { Equity } from 'src/app/_models/equity';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-cash-dividends',
  templateUrl: './cash-dividends.component.html',
  styleUrls: ['./cash-dividends.component.css']
})

export class CashDividendsComponent implements OnInit {

  // Because they come as 2 different transfers : Withholding tax & Dividend
  cashDividendsIncludingTax: CashDividend[] = [];
  allCashDividendsInBase: number = 0;
  allWithholdTaxInBase: number = 0;
  dividendAccruals: number = 0;
  filterValueSYEP: string = 'YIELD ENHANCEMENT INCOME';
  filterValueCreditWithHolding: string = 'ON CREDIT INT';
  yearlyReportYear: number;

  equityData: Equity[];
  constructor(private httpRequestService: HttpRequestService,
    private dataSharingService: DataSharingService,
    private router: Router) { }
  ngOnInit() {
    this.getEquityAndCalculateDividends();
  }

  getEquityAndCalculateDividends() {
    return this.httpRequestService.equityData.pipe(tap(responseData => {
      this.resetValues();
      if (responseData.length === 0) return
      this.equityData = responseData;
      this.computeData();
    })).toPromise();
  }

  computeData() {
    this.allowOnlyOneYearlyReportYear();
    this.equityData.map(x => x.transfers.filter(x => {
      return x.instrumentSecurityType !== 'BOND' && x.description.indexOf(this.filterValueSYEP) === -1 &&
        x.description.indexOf(this.filterValueCreditWithHolding) === -1 &&
        x.date && (x.typeDescription === "Dividends" || x.typeDescription === "Withholding Tax" || x.typeDescription === "Payment In Lieu Of Dividends") &&
        (this.yearlyReportYear ? moment(x.date).year() === this.yearlyReportYear : true)
    })).filter(y => y.length != 0).forEach(transfersInOneDay => {
      for (let transfer of transfersInOneDay) {
        let cashDividend = new CashDividend();
        if (this.isDividendAlreadyAdded(transfer)) {
          this.cashDividendsIncludingTax.filter(element => element.date === transfer.date && element.instrumentContractId === transfer.instrumentContractId).forEach(existingTransfer => {
            this.calculateDividend(existingTransfer, transfer);
          });
        }
        else {
          // Get properties (keys & values) from transfer to Dividend
          Object.keys(cashDividend).forEach(key => {
            if (transfer[key] != undefined)
              cashDividend[key] = transfer[key];
          });
          this.calculateDividend(cashDividend, transfer);
          this.cashDividendsIncludingTax.push(cashDividend);
        }
      }
    });

    this.dividendAccruals = this.equityData[this.equityData.length - 1].assets.dividentAccruals;
    this.dataSharingService.sendDividendsTotal(this.allCashDividendsInBase + this.allWithholdTaxInBase);
    this.dataSharingService.sendCashDividends(this.cashDividendsIncludingTax);
  }

  calculateDividend(cashDividend: CashDividend, transfer) {
    if (transfer.typeDescription === "Dividends" || transfer.typeDescription === "Payment In Lieu Of Dividends") {
      this.addValueToDividend(cashDividend, transfer);
    }
    else {
      this.addTaxToDividend(cashDividend, transfer);
    }
  }

  private allowOnlyOneYearlyReportYear() {
    if (this.router.url.includes('yearlyReport')) {
      let timeframe = this.httpRequestService.getTimeframe();
      if (timeframe.startDate.year() === timeframe.endDate.year()) {
        this.yearlyReportYear = timeframe.startDate.year();
      }
    }
  }

  addTaxToDividend(cashDividend: CashDividend, transfer) {
    cashDividend.withholdTaxValue += transfer.value as number;
    cashDividend.withholdTaxValueOriginal += transfer.valueOriginal as number;
    this.allWithholdTaxInBase += transfer.value as number;
  }

  addValueToDividend(cashDividend: CashDividend, transfer) {
    cashDividend.dividendValue += transfer.value as number;
    cashDividend.dividendValueOriginal += transfer.valueOriginal as number;
    this.allCashDividendsInBase += transfer.value as number;
  }

  isDividendAlreadyAdded(transfer): boolean {
    return (this.cashDividendsIncludingTax.filter(element => element.date === transfer.date && element.instrumentContractId === transfer.instrumentContractId)).length !== 0;
  }

  resetValues() {
    this.cashDividendsIncludingTax = [];
    this.allCashDividendsInBase = 0;
    this.allWithholdTaxInBase = 0;
  }
}
